import React from "react"
import { Outlet } from "react-router-dom"
import _ from "lodash"
import { Button } from "@mui/material"
import { RefreshOutlined } from "@mui/icons-material"
import { useLazyGetInstitutionClassesQuery } from "../Redux/actions/classSetup.action"
import { GetCurrentUser } from "../utils/hooks"
import CreateSubject from "./component/Classes"

export default function SubjectRootLayout() {
    const [getClassesAction, getClassesState] = useLazyGetInstitutionClassesQuery()

    const getClassess = () => {
        const user_platform = _.get(GetCurrentUser(), "meta_data.user_platform", null)
        if (user_platform) getClassesAction({ institution_ref: user_platform })
    }

    React.useEffect(() => {
        getClassess()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const classes = React.useMemo(() => {
        const list = _.get(getClassesState, "data.list", [])
        return Array.isArray(list) ? list : []
    }, [getClassesState])

    return (
        <div className="mx-auto w-full max-w-[1400px] px-4 pb-24 pt-6 sm:px-6 lg:px-8">
            <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-wider text-indigo-600">Academics</p>
                    <h1 className="mt-1 text-2xl font-bold text-slate-900 sm:text-[28px]">Class Subjects</h1>
                    <p className="mt-1 max-w-xl text-sm text-slate-500">
                        Set up each class's main and minor subjects and assign their teachers.
                    </p>
                </div>
                <Button
                    variant="outlined"
                    color="inherit"
                    startIcon={<RefreshOutlined />}
                    onClick={getClassess}
                    disabled={getClassesState.isFetching}
                    sx={{ textTransform: "none", borderRadius: "10px", borderColor: "#e2e8f0", color: "#334155" }}
                >
                    Refresh
                </Button>
            </header>

            <CreateSubject
                classList={classes}
                getClassess={getClassess}
                loading={getClassesState.isLoading || getClassesState.isFetching}
            />

            {/* Route content (/subjects/:class_name) */}
            <Outlet />
        </div>
    )
}
